import { useUpdateQuery } from "hooks/useQuery";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { BrandCreationForm } from "./BrandCreationForm";
import { EntityCreationForm } from "./EntityCreationForm";

export const BrandEntityCreateWrapper = ({
  groupName = "",
  isFromAdmin = false,
  moveBack,
  onAdminSubmit,
  isEntityCreate,
  setEntityCreate,
  moveNext,
}: {
  groupName?: string;
  isFromAdmin?: boolean;
  moveBack?: () => void;
  onAdminSubmit?: (
    values: {
      state_id: string | null;
      formation_type_id: string;
      company_name: string;
    }[]
  ) => void;
  isEntityCreate?: boolean;
  setEntityCreate?: (val: boolean) => void;
  moveNext?: () => void;
}) => {
  const location = useLocation();
  const { update } = useUpdateQuery();
  const hasInitialized = useRef(false);

  const searchParams = new URLSearchParams(location.search);
  const stepFromUrl = searchParams.get("step");

  useEffect(() => {
    if (stepFromUrl === "entity" && !isEntityCreate) {
      setEntityCreate?.(true);
      hasInitialized.current = true;
    } else if (stepFromUrl === "brand" && isEntityCreate) {
      setEntityCreate?.(false);
      hasInitialized.current = true;
    } else if (!stepFromUrl && !hasInitialized.current) {
      const initialStep = isEntityCreate ? "entity" : "brand";
      update({ query: "step", value: initialStep });
      hasInitialized.current = true;
    }
  }, [stepFromUrl, setEntityCreate, isEntityCreate, update]);

  const updateUrlStep = (step: "brand" | "entity") => {
    update({ query: "step", value: step });
  };

  if (isEntityCreate) {
    return (
      <div className="t-h-full t-flex t-flex-col t-overflow-hidden sm:t-overflow-visible">
        <EntityCreationForm
          groupName={groupName}
          isFromAdmin={isFromAdmin}
          moveBack={moveBack}
          onAdminSubmit={onAdminSubmit}
          setEntityCreate={(val) => {
            setEntityCreate?.(val);
            updateUrlStep(val ? "entity" : "brand");
          }}
        />
      </div>
    );
  }

  return (
    <div className="t-h-full t-flex t-flex-col t-overflow-hidden t-mt-[72px] sm:t-mt-8 sm:t-overflow-visible">
      <BrandCreationForm
        groupName={groupName}
        isFromAdmin={isFromAdmin}
        setEntityCreate={(val) => {
          setEntityCreate?.(val);
          updateUrlStep(val ? "entity" : "brand");
        }}
        moveBack={moveBack}
        moveNext={moveNext}
      />
    </div>
  );
};
